import trainingPhaseRemedialsActionCreators from './training-phase-remedials';
import trainingPhaseReportsActionsCreators from './training-phase-reports';
import trainingPhaseReportNotesActionsCreators from './training-phase-report-notes';
import trainingPhaseReportAttachmentsActionsCreators from './training-phase-report-attachments';
import trainingPhaseScheduledReportsActionsCreators from './training-phase-scheduled-reports';
import trainingPhases from './training-phases';

const trainingPhasesActionCreators = {
  ...trainingPhaseRemedialsActionCreators,
  ...trainingPhaseReportsActionsCreators,
  ...trainingPhaseReportAttachmentsActionsCreators,
  ...trainingPhaseReportNotesActionsCreators,
  ...trainingPhaseScheduledReportsActionsCreators,
  ...trainingPhases,
};

export default trainingPhasesActionCreators;
